// AuthLayout.js
import { useEffect } from "react";
import "./AuthLayout.scss"; // You can add your styles here
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthenticated } from "../../../Routes/AuthHelper";
const AuthLayout = () => {
  const isAuthentic = isAuthenticated();
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthentic) {
      // Check for redirect URL from sessionStorage
      const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
      if (redirectUrl) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectUrl, {
          replace: true,
        });
      } else {
        navigate("/sales", {
          replace: true,
        });
      }
    }
  }, [isAuthentic, navigate]);

  return <div className="auth-layout">{!isAuthentic && <Outlet />}</div>;
};

export default AuthLayout;
